import classes from 'classnames';
import React from 'react';
import styles from './TableRow.module.scss';

export type TableRowProps = {
  name?: string;
  label: string;
  value?: string;
  secondaryValue?: string;
  isStrong?: boolean;
  dataTest?: string;
  className?: string;
  classNameValue?: string;
};

export default function TableRow({
  label,
  value,
  secondaryValue,
  isStrong = false,
  className,
  classNameValue,
  dataTest,
}: TableRowProps) {
  return (
    <div
      className={classes(
        styles.row,
        isStrong && styles.strong,
        secondaryValue && styles['row-with-secondary'],
        className,
      )}
      data-test={dataTest}
    >
      <div
        dangerouslySetInnerHTML={{ __html: label }}
        data-test={`${dataTest}-label`}
      ></div>
      <div className={classes(styles.value, classNameValue)}>
        <span data-test={`${dataTest}-primary-value`}>{value}</span>
        {secondaryValue && (
          <div
            className={styles['secondary-value']}
            data-test={`${dataTest}-secondary-value`}
          >
            {secondaryValue}
          </div>
        )}
      </div>
    </div>
  );
}
